function sanitizeKey(key: string) {
    if (key.endsWith('r')) return key.slice(0, -1);
    return key;
}

function createProductRulesFromKeys(keys: string[]) {
    const rule = `incl product_key { % }`;
    const list = keys.map((key) => `"${sanitizeKey(key)}__P"`);
    const output = rule.replace('%', list.join(' '));
    return output;
}

function createProductRulesFromFlag(flag: Flag) {
    const { key, value } = flag;
    return `incl ${key} { "${value}" }`;
}

export type Flag = {
    key: string;
    value: string;
};

export default function makeProductRules(
    ...rulesets: (Flag | Array<string>)[]
) {
    return (
        'rule ' +
        rulesets
            .map((ruleset) => {
                if (Array.isArray(ruleset)) {
                    return createProductRulesFromKeys(ruleset);
                }
                return createProductRulesFromFlag(ruleset);
            })
            .join(' ')
    );
}
